import { render, staticRenderFns } from "./skus-list.vue?vue&type=template&id=55e2eeff&scoped=true"
import script from "./skus-list.vue?vue&type=script&lang=js"
export * from "./skus-list.vue?vue&type=script&lang=js"
import style0 from "./skus-list.vue?vue&type=style&index=0&id=55e2eeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2eeff",
  null
  
)

export default component.exports